export default __webpack_public_path__ + "cf0a20c21bb8486e84ba84b54668a425.png";